/* istanbul ignore file */
import { useTranslation } from 'react-i18next';
import emptyGridImage from "../../../assets/img/empty-grid-placeholder.svg";

export const EmptyGridMessage = () => {
  const { t } = useTranslation();
  return (
    <div className="user-management-empty" data-testid="no-users">
      <img src={emptyGridImage} alt="no users" />
      <span
        className="user-management-empty__header"
        data-testid="no-users-header"
      >
        {t("userManagementPage.emptyGridTitle")}
      </span>
      <span
        className="user-management-empty__description"
        data-testid="no-users-description"
      >
        {t("userManagementPage.emptyGridMessage")}
      </span>
    </div>
  )
}